import React from 'react'
import _ from 'lodash'
import SolutionRow from '../../components/SolutionRow'
import StudentQualityList from '../../components/StudentQualityList'
import '../../assets/css/pages/track_progress/categorization-submissions.css'

const CategorizationSubmissions = props => {
  const { description, submissions } = props

  const getStudentListTitle = answer =>
    answer.isCorrect ? 'STATUS BREAKDOWN' : undefined

  const getStudentListText = answer =>
    answer.isCorrect ? undefined : `${parseInt(answer.percentage*100)}% of this group of students submitted this incorrect answer`

  const getStatementText = text => text === '~' ? <i>This categorization option does not have any text.</i> : text

  return(
    <div className='categorization-submissions'>
      <div className='task'>
        <div className='header-item'>
          <span>TASK: </span>
          <span>{description}</span>
        </div>
      </div>
      <div className='statements-wrapper'>
        {_.map(submissions, sub =>
          <div key={JSON.stringify(sub)} className='statment-wrapper'>
            <div className='statement'>
              <div className='title'>Statement:</div>
              <p>{getStatementText(sub.statement)}</p>
            </div>
            <div className='answers'>
              {_.map(sub.answers, answer =>
                <div key={JSON.stringify(answer)} className='answer'>
                  <SolutionRow type={answer.isCorrect ? 'correct' : 'incorrect'}>
                    {answer.selection}
                  </SolutionRow>
                  <StudentQualityList
                    title={getStudentListTitle(answer)}
                    text={getStudentListText(answer)}
                    students={answer.students}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CategorizationSubmissions
